class AuthError extends Error {
    constructor(params) {
        const { message = 'Auth Unknown error' } = params || {};
        super(message);
        // capturing the stack trace keeps the reference to your error class
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}

export { AuthError };
//# sourceMappingURL=AuthError.js.map
